import React, { useEffect } from "react";
import { resumeEducation, resumeProfessionalExperience } from "./data";
import ResumeSection from "./ResumeSection"; // Importing the new modular component
import AOS from "aos";  // Importing AOS for animations
import "aos/dist/aos.css";  // Import AOS styles

export default function Resume() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <section id="resume" className="resume">
      <div className="container">
        <div className="section-title" data-aos="fade-up">
          <h2>Resume</h2>
          <p></p>
        </div>

        <div className="row">
          <div className="col-lg-6">
            <ResumeSection
              title="Education"
              data={resumeEducation}
              type="education"
            />
          </div>

          <div className="col-lg-6">
            <ResumeSection
              title="Professional Experience"
              data={resumeProfessionalExperience}
              type="experience"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
